function checkTagIdInUrl() {
    // Get the current URL
    const url = window.location.href;

    const element = document.getElementById('block-felfedetturlapblog-postsblock-1');

    if (!url.includes('tag_id')) {

        if (element && element.parentElement && element.parentElement.parentElement) {
            element.parentElement.parentElement.style.display = 'block';
        }
    } else {
        if (element && element.parentElement && element.parentElement.parentElement) {
            element.parentElement.parentElement.style.display = 'none';
        }
    }
}

checkTagIdInUrl();